/**
 * Axios
 */
import axios from "axios";
window.axios = axios;

window.axios.defaults.baseURL = WP.base_url;
window.axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

import "./_warranty-request";

jQuery(document).on("submit_success", function (event, { data }) {
  const { popup } = data;

  // Formulario descuento Kask.
  if (popup.id == 743) {
    jQuery("#js-modal-code").html(data.coupon);
  }
});
